import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { USER_ROLE } from 'src/app/shared/enum/role.enum';
import { UserInfo } from 'src/app/shared/models/user-info.model';
import { AuthService } from '../services/auth.service';
import { } from 'src/app/shared/utils/utils-global';
import { ToastService } from 'src/app/core/services/toast.service';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from '../services/message.service';
import { ADMIN_ROUTER } from 'src/app/shared/constants/app-router';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(private router: Router
    , private authService: AuthService
    , private toastService: ToastService
    , private translateService: TranslateService
    , private messageService: MessageService
  ) {
    console.debugEx("AuthGuard.CTOR");
  }

  public canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean> {
    let url: string = state.url;
    console.debugEx(`AuthGuard.canActivate: url = ${url}`);
    return this.checkUserLogin(next, url);
  }

  private checkUserLogin(
    route: ActivatedRouteSnapshot,
    url: any,
  ): Observable<boolean> {
    return this.authService.getCurrentUser().pipe(
      map((user: UserInfo) => {
        const {
          data: { allowedRole },
        } = route;

        const currentRoutePath = route.routeConfig?.path;

        console.debugEx(`AuthGuard.CheckUserLogin: user = ${user.fullName} (${user.employeeNb})`);

        if (!user.hasAccess(allowedRole)) {

          const msgFormat: string = this.translateService.instant("MY_PROFILE.RedirectToDefaultPage");

          let msg: string = msgFormat
            .replace("{{requestedPage}}", `${(route.url && route.url.length > 0) ? route.url[0] : "default"}`)
            .replace("{{defaultPage}}", user.defaultPage);

          this.toastService.showWarn(msg);

          this.router.navigate([user.defaultPage], { queryParams: { ...route.queryParams } });
          return false;
        }

        // ✅ NEW CONDITION (ONLY for log-download)
        if (
          currentRoutePath === ADMIN_ROUTER.LOG_DOWNLOAD.ROUTER &&
          !user.isDevUser
        ) {

          const msg = this.translateService.instant('MY_PROFILE.RedirectToDefaultPage');
          this.toastService.showError(msg);

          console.debugEx(`AuthGuard: ${user.fullName} is ADMIN but NOT sustain member → blocking log download`);

          this.router.navigate([user.defaultPage], { queryParams: { ...route.queryParams } });
          return false;
        }

        // ✅ ALLOWED
        return true;

      }),
      catchError(error => {
        this.messageService.set('ERRORS.PAGE_NOT_FOUND');
        this.router.navigate(['/messages']);
        return of(false);
      }),
    );
  }
}
